import styled from 'styled-components';

const StyledSearch = styled.div`
        align-items: center;
        background-color: ${props => props.toolbar ? props.theme.palette.common.white : "transparent" };
        box-shadow: ${props => props.theme.shadows[2]};
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        font-size: ${props => props.toolbar ? "0.9em" : "inherit" };
        justify-content: flex-start;
        margin: 3px auto 3px;
        max-width: ${props => props.theme.space[23]};
        padding: 0;
        width: ${props => props.toolbar ? "100%" : "90vw"};
      
        &:focus-within {
          border-color: ${props => props.theme.palette.common.secondary};
          box-shadow: ${props => props.theme.shadows[5]};
        }
    `;

export default StyledSearch;



// WEBPACK FOOTER //
// ./src/components/styles/Search.js